module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"ui":{"views":{"users":{"show":{"types":{"advisor":"Berater","expert":"Experte","institutional_investor":"Institutioneller Investor","private":"Privater Investor","product_provider":"Produktanbieter","professional":"Professioneller Investor","professional_investor":"Professioneller Investor"}}}}}}}')
  delete Component.options._Ctor
}
